import React from 'react'
import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { BasePublisherPhoneNumberField } from '../../base-publisher-field/base-publisher-phone-number-field'
import { useFormField } from '../hooks/use-form-field'

interface FormPhoneNumberFieldSubEntityProps {
  fieldSubEntity: FormFieldInterface
}

export const FormPhoneNumberFieldSubEntity = ({
  fieldSubEntity,
}: FormPhoneNumberFieldSubEntityProps) => {
  const { value, onChange, errors } = useFormField({
    fieldSubEntity,
  })
  return (
    <BasePublisherPhoneNumberField
      entity={fieldSubEntity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
